import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
  Button,
  Text,
} from "@musa.tech/design-system";
import { X, AlertCircle } from "lucide-react";
import { DocumentSkeleton } from "./FinanceSkeletons";

interface InvoiceDocumentModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  fatura: {
    title: string;
    subtitle: string;
  } | null;
  tipo: 'boleto' | 'nf';
  documentUrl?: string | null;
  isLoadingUrl?: boolean;
}

export const InvoiceDocumentModal: React.FC<InvoiceDocumentModalProps> = ({
  open,
  onOpenChange,
  fatura,
  tipo,
  documentUrl,
  isLoadingUrl = false,
}) => {
  if (!fatura) return null;

  const label = tipo === 'boleto' ? 'Download boleto' : 'Download NF';
  const iframeSrc = documentUrl ? `${documentUrl}#navpanes=0` : undefined;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl bg-white rounded-lg" hideCloseButton>
        <DialogHeader>
          <div className="flex justify-between items-start">
            <div>
              <DialogTitle>
                <Text as="span" variant="heading" size="large" className="text-neutral-900">
                  {fatura.title}
                </Text>
              </DialogTitle>
              <DialogDescription className="mt-1">
                <Text as="span" variant="body" size="small" className="text-neutral-500">
                  {fatura.subtitle}
                </Text>
              </DialogDescription>
            </div>
            <DialogClose asChild>
              <Button variant="ghost" size="icon" aria-label="Fechar">
                <X className="h-4 w-4" />
              </Button>
            </DialogClose>
          </div>
        </DialogHeader>

        {isLoadingUrl ? (
          <DocumentSkeleton />
        ) : iframeSrc ? (
          <iframe
            src={iframeSrc}
            className="w-full"
            style={{ height: '520px', border: 'none', borderRadius: '8px' }}
            title={label}
          />
        ) : (
          <div className="flex flex-col items-center justify-center py-16 gap-3 text-neutral-400">
            <AlertCircle className="h-8 w-8" />
            <Text variant="body" size="small" className="text-neutral-500">
              Documento não disponível
            </Text>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
